import { StandardFooter } from './StandardFooter'

export default StandardFooter
